import Utils from '../../../scripts/vendors/utils';

/**
 * Feature
 * @class
 * @constructor
 * @public
 */
class Feature {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.components = document.querySelectorAll('[data-feature]');

    // Settings
    this.settings = {
      animationDuration: 2000,
      frameDuration: 1000 / 60,
      easeOutQuad: t => t * ( 2 - t )
    };

    // Engage engines
    if (this.components) {
      this.components.forEach((component) => {
        this.init(component);
      });
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init(component) {
    const facts = component.querySelectorAll('[data-feature-fact]');

    if (facts.length) {
      facts.forEach((fact) => {
        fact.textContent = 0;
      });
      window.addEventListener('scroll', Utils.events.throttle(this.onScroll.bind(this, facts), 250, this));
      window.dispatchEvent(new CustomEvent('scroll'));
    }
  }

  /**
   * Trigger animations when elements are in viewport
   * @returns {void}
   */
  onScroll(facts) {
    facts.forEach((fact) => {
      const countTo = parseInt(fact.getAttribute('data-feature-fact'), 10) || false;
      if (countTo && !fact.classList.contains('was-animated')) {
        if (Utils.intersect.isElementInViewport(fact, 30)) {
          this.animateNumber(fact, countTo);
          fact.classList.add('was-animated');
        }
      }
    });
  }

  /**
   * Count numbers up to given number
   * @returns {void}
   */
  animateNumber(el, countTo) {
    let frame = 0;
    const totalFrames = Math.round( this.settings.animationDuration / this.settings.frameDuration );
    const counter = setInterval( () => {
      frame++;
      const progress = this.settings.easeOutQuad( frame / totalFrames );
      const currentCount = Math.round( countTo * progress );
      if ( parseInt( el.textContent, 10 ) !== currentCount ) {
        el.textContent = currentCount;
      }
      if ( frame === totalFrames ) {
        clearInterval( counter );
      }
    }, this.settings.frameDuration );
  }

}

module.exports = Feature;
